module.exports = __webpack_public_path__ + "static/media/a_of_diamonds.340596a1.png";